export default function(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition;
      } else {
        return { x: 0, y: to.meta.savedPosition || 0 };
      }
    }
